<template>
    <div>
        <v-img  src="@/assets/images/Solar.jpg" height="60px;" width="100%;">
        <v-row align="end" class="lightbox white--text pa-2 fill-height">
          <v-col>
            <div class="subheading"><h1 class="ml-4">SunLine Water Heaters Quotation</h1></div>
          </v-col>
        </v-row>
      </v-img>

    <v-card class="mx-auto" ml-3>
    <v-card-text>
      <v-form id="frmNewQuote" v-model="valid" @submit.prevent="SendQuotation">
    <v-container class="pa-md-4 pa-sm-4 pa-xs-4 mx-lg-auto">
        <v-card shaped class="pa-md-4 pa-sm-4 pa-xs-4 mx-lg-auto" elevation="3">
            <div><strong class="blue--text darken-4">Client Details</strong></div>
            <v-row>
                <v-col cols="12" md="4">
                <v-text-field v-model="Firstname" :rules="nameRules" :counter="10" label="First name" required></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                <v-text-field v-model="Lastname" :rules="LastnameRules" :counter="10" label="Last name" required></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                <v-text-field v-model="Email" :rules="emailRules" label="E-mail" required></v-text-field>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" md="6">
                    <v-text-field v-model="MobileNumber" :items="installTypes" label="Day Time Phone"></v-text-field>
                </v-col>
            </v-row>
        </v-card>

        <v-card shaped class="pa-md-4 pa-xs-4 mt-md-5 mx-lg-auto" elevation="3">
            <br>
            <div><strong class="blue--text darken-4">Tell Us About Where You Would Like To Install The Solar Water Heater</strong></div>
            <v-row>
                <v-col cols="12" md="4">
                    <v-select v-model="InstallationType" :items="installTypes" label="Installation Type"></v-select>
                </v-col>
                <v-col cols="12" md="4">
                    <v-text-field v-model="BirthRooms" label="Number Of Bathrooms" required></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                    <v-select v-model="HeaterPlacement" :items="placements" label="Installation Placement"></v-select>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" md="6">
                    <v-select v-model="ConstantWaterSupply" :items="YesOrNo" label="Do You Have A Constant Water Supply?"></v-select>
                </v-col>
                <v-col cols="12" md="6">
                    <v-text-field v-model="NumberOfUsers" label="Number Of Users"></v-text-field>
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="12" md="10">

                    <v-textarea
                    outlined
                    name="input-7-1"
                    v-model="Remarks"
                    label="Remarks"
                    value="The Woodman set to work at once, and so sharp was his axe that the tree was soon chopped nearly through."
                    hint="Any Other Details You Might Want Us To Know"
                  ></v-textarea>
                </v-col>
                <v-col cols="12" md="2">
                    <v-btn text class="blue darken-3" dark type="submit">SEND</v-btn>
                </v-col>
            </v-row>

      <v-row v-if="sendingEmail" class="fill-height" align-content="center" justify="center">
          <v-col class="subtitle-1 text-center" cols="12">
            Sending...
          </v-col>
          <v-col cols="6">
            <v-progress-linear color="yellow accent-4" indeterminate rounded height="6"></v-progress-linear>
          </v-col>
      </v-row>

        </v-card>

      <v-bottom-sheet v-model="formError">
        <v-sheet class="text-center red darken-3 mb-4" height="200px" dark>
          <v-btn class="mt-6" flat color="blue darken-3 mb-4" dark @click="formError = !formError">close</v-btn>
          <div dark>{{formErrorMessage}}</div>
        </v-sheet>
      </v-bottom-sheet>

    </v-container>
  </v-form>
    </v-card-text>

  </v-card>

    </div>
</template>

<script>
export default {
  data () {
    return {
      Firstname: null,
      Lastname: null,
      Email: null,
      MobileNumber: null,
      InstallationType: null,
      BirthRooms: null,
      HeaterPlacement: null,
      NumberOfUsers: null,
      ConstantWaterSupply: null,
      Remarks: null,
      valid: false,
      installTypes: ['COMMERCIAL', 'RESIDENTIAL', 'TERTIARY'],
      placements: ['ROOF', 'GROUND'],
      YesOrNo: ['YES', 'NO'],
      formError: false,
      formErrorMessage: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => v.length <= 10 || 'Name must be less than 10 characters'
      ],
      LastnameRules: [
        v => !!v || 'Last Name is required',
        v => v.length <= 10 || 'Name must be less than 10 characters'
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ]
    }
  },
  computed: {
    sendingEmail () {
      return this.$store.getters.getLoading
    }
  },
  methods: {
    SendQuotation () {
      const MnewQuote = {
        FirstName: this.Firstname,
        Lastname: this.Lastname,
        Email: this.Email,
        MobileNumber: this.MobileNumber,
        InstallationType: this.InstallationType,
        BirthRooms: this.BirthRooms,
        HeaterPlacement: this.HeaterPlacement,
        ConstantWaterSupply: this.ConstantWaterSupply,
        NumberOfUsers: this.NumberOfUsers,
        Remarks: this.Remarks
      }
      console.log(MnewQuote)

      if (this.Firstname == null || this.Lastname == null || this.Email == null) {
        this.formError = true
        this.formErrorMessage = 'Please Make Sure You Have Entered Your First Name, Last Name And Email Address'
      } else if (this.InstallationType == null) {
        this.formError = true
        this.formErrorMessage = 'Please Provide Us With All The Required Installation Details To Better Understand What You Are Looking At'
      } else {
        const newQuote = {
          FirstName: this.Firstname,
          Lastname: this.Lastname,
          Email: this.Email,
          MobileNumber: this.MobileNumber,
          InstallationType: this.InstallationType,
          BirthRooms: this.BirthRooms,
          HeaterPlacement: this.HeaterPlacement,
          ConstantWaterSupply: this.ConstantWaterSupply,
          NumberOfUsers: this.NumberOfUsers,
          Remarks: this.Remarks
        }
        // Create Mailer Object Here
        this.$store.dispatch('sendQuote', newQuote)
      }
    }
  }

}
</script>
